import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { formatDate, formatToZMW, numberToWords, rootUrl, sumOfArray } from "../helpers";
import { useAuth } from "../context/auth-context";
import axios from "axios";
import { toast } from "react-toastify";

const PaymentVoucher = React.forwardRef(({ data }, ref) => {
  
  const {allData, setAllData} = useOutletContext();
  const auth = useAuth();
  const [voucherData, setVoucherData] = useState({
    preparedBy: {},
    checkedBy: {},
    authorisedBy: {},
    approvedBy: {},
    receivedBy: {},
    budgetDetails: [],
  });

  const {
    commitmentRefNo,
    cheque,
    voucher,
    paye,
    batchNo = "",
    journalNo = "",
    bSheetNo = "",
    date,
    purchaseOrderNo = "",
    chequeNumber = "",
    description,
    invoiceNumber = description?.split(':')[0]?.split('-')[1]?.trim(),
    amount,
    bank = "",
    accountNo = "",
    updatedBy,
  } = data;


  const [allneeded, setAllneeded] = useState([])

  const getSupData = async () => {

      try{
        const response = await axios.post(rootUrl(`/getInvoice`), {
          voucher:voucher,
          sid:paye
        });
        setAllneeded(response.data.data)
        
      }catch(e){
        toast.error(e?.message)
      }
  }
  
  
  const getOtherDetails = async () => {
    try {
      const response = await axios.get(rootUrl(`/getDetails/${data.id}`));
      const { other, actions } = response.data;
      const user = allData.users?.find((a) => a.u_id == updatedBy);
      const preparerName = `${user?.firstname || ""} ${user?.lastname || ""}`;
      
      const createSignerDetails = (actionIndex) => {
        const user = allData.users?.find(
          (a) => a.u_id === actions[actionIndex]?.uid
        );
        return {
          name: `${user?.firstname || ""} ${user?.lastname || ""}`,
          signature: "",
          date: actions[actionIndex]?.date,
        };
      };

      setVoucherData({
        preparedBy: {
          name: preparerName,
          signature: "",
          date: formatDate(date),
        },
        // checkedBy: createSignerDetails(0),
        // authorisedBy: createSignerDetails(1),
        // approvedBy: createSignerDetails(2),
        checkedBy: {
          name: '',
          signature: '',
          date: '',
        },
        authorisedBy: {
          name: '',
          signature: '',
          date: '',
        },
        approvedBy: {
          name: '',
          signature: '',
          date: '',
        },
        receivedBy: {
          name: other?.receivedByName || "",
          address: other?.address || "",
          signature: "",
          nrc: other?.nrc || "",
          date: other?.date || "",
          contactNo: other?.contactNo || "",
        },
        budgetDetails: allData.budget?.filter(
          (budget) => budget.id == data.coa_id
        ),
      });
    } catch (error) {
      console.error("Error fetching additional details:", error);
    }
  };

  useEffect(() => {
    getOtherDetails();
    getSupData();
  }, []);

  
  

  const renderBudgetDetails = () => {
    return (
      <table className="mt-1 border-collapse w-full">
        <tbody>
        <tr>
              <td colSpan={3} className="border border-gray-700">
                ACCOUNT NAME: <strong>{allData.bank.find(a=>a.id === bank)?.name}</strong>
              </td>
              <td colSpan={2} className="border border-gray-700">
                ACCOUNT NO: <strong>{allData.bank.find(a=>a.id === bank)?.account_no}</strong>
              </td>
            </tr>
            <tr>
              <th colSpan={5} className="border border-gray-700 text-center">
                BUDGET ALLOCATION DETAILS
              </th>
            </tr>
            <tr>
              {['Head', 'Dept', 'Item-Name', 'Account Code', 'K'].map((header) => (
                <th key={header} className="border border-gray-700 p-1 text-left">
                  {header}
                </th>
              ))}
            </tr>
          {allneeded.filter(a=>a.type == 'expense').map((row, index) => {
            const bItems = allData.budget?.filter(
              (budget) => budget.id == row.coa_id
            )[0]
            return(
              <tr key={index} className="text-center">
              <td className="border border-gray-700 p-1">{auth.user.cid}</td>
              <td className="border border-gray-700 p-1">{allData.dept.find(a=>a.id === bItems?.dept)?.name || "Finance"}</td>
              <td className="border border-gray-700 p-1">{allData.coa.find(a=>a.account == bItems?.coa)?.name || ""}</td>
              <td className="border border-gray-700 p-1">{bItems?.coa || ""}</td>
              <td className="border border-gray-700 p-1">
                {formatToZMW(row?.amount)}
              </td>
              
            </tr>
            )
          })}

          <tr>
            <th className="border border-gray-700 p-1" colSpan={4}>
              Total
            </th>
            <th className="border border-gray-700 p-1 text-center">
              {formatToZMW(sumOfArray(allneeded.filter(a=>a.type == 'expense').map(res=>parseFloat(res?.amount))))}
            </th>
          </tr>
        </tbody>
      </table>
    );
  };

  const renderSignerSection = (title, signer) => (
    <div className="border border-gray-700 p-1">
      {console.log(signer)}
      <p className="font-semibold">{title}</p>
      <p>Name: {signer?.name || ''}</p>
      <p>Signature: {signer?.signature || ''}</p>
      <p>Date: {signer?.date || ''}</p>
      <p>Designation: </p>
    </div>
  );

  return (
    <div
      ref={ref}
      className=""
    >

      {/* Header Section - Logo and Council Name */}
      <div className="text-center mb-4">
        <div className="flex justify-center mb-2">
          <img 
            className="w-[100px] h-[100px] object-contain" 
            src={rootUrl(`/${allData?.council[0]?.path}`)} 
            alt="Council Logo" 
          />
        </div>
        <h3 className="font-bold">
          <span className="text-2xl">{allData.council[0]?.name.toUpperCase()}</span>
        </h3>
        <div className="text-xl font-bold underline">PAYMENT VOUCHER</div>
      </div>

      {/* Payment Details Section */}

      <div className="grid grid-cols-2 gap-2 items-center">
        <div>
        <p className=""><strong>COMMITMENT REF NO:</strong> {commitmentRefNo}</p>
        <p className=""><strong>PAYMENT VOUCHER NO:</strong> {voucher}</p>
        </div>

        <div>
        <h2 className="text-center font-bold">BATCH HEADER DETAILS</h2>
      {/* Batch Number */}
      <div className="flex">
        <span className="font-semibold  w-32">BATCH NO.</span>
        <span className="border-b border-black flex-1">{data.batchNo}</span>
      </div>
        </div>
      </div>
    
        <div className="mt-1 flex gap-4 items-center">
        <div className="w-[40%]">
            <p className="border border-gray-400 text-xl font-semibold  p-2 pb-[20%]">
              <strong>PAYEE:</strong> 
              <br />  
            
              {allData.suppliers?.find((a) => a.id == paye)?.name || allData.bank?.find((a) => a.id == allneeded.find(a=>a.type == 'income')?.bank)?.name}
            </p>
          </div>
  
  
          <div className="w-[60%]">
          <div className="max-w-2xl mx-auto  bg-white">
      

      <div className="border border-gray-400 p-1">

      {/* Journal No. & B/Sheet No. */}
         
         <div className="flex w-full">
         <div className="w-1/2 items-center">
        <span className="font-semibold text-[15px] w-1/4">JOURNAL NO.:</span>
        <div className="flex space-x-1">
        {["","","",""].map((char, index) => (
        <div
          key={index}
          className="w-3 h-3 border border-black flex items-center justify-center text-sm p-2"
        >
          {char}
        </div>
      ))}

        </div>
      </div>
  
      <div className="w-1/2 items-center">
        <span className="font-semibold text-[15px] w-1/4">B/SHEET NO.:</span>
        <div className="flex space-x-1">
        {["","",""].map((char, index) => (
        <div
          key={index}
          className="w-3 h-3 border border-black flex items-center justify-center text-sm  p-2"
        >
          {char}
        </div>
      ))}

        </div>
      </div>
      </div>

      {/* Other Details */}
      <div className=" flex items-center">
        <span className="font-semibold text-[15px] w-[40%] w-1/4">Date:</span>
        <div className="flex space-x-1 mt-1">
        {`${date.substring(8,10)}/${date.substring(5,7)}/${date.substring(0,4)}`?.split("").map((char, index) => (
  <div
    key={index}
    className="w-3 h-3 border border-black flex items-center justify-center  text-sm p-2"
  >
    {char}
  </div>
))}

        </div>
      </div>

      <div className=" flex items-center">
        <span className="font-semibold text-[15px] w-[40%] w-1/4">Purchase Order No:</span>
        <span className="border-b border-black ml-2 px-20">{purchaseOrderNo}</span>
      </div>

      <div className=" flex items-center">
        <span className="font-semibold text-[15px] w-[40%] w-1/4">Invoice Number:</span>
        <span className={`border-b border-black ml-2 ${invoiceNumber == '' || invoiceNumber == undefined?'px-20':''}`}>{invoiceNumber}</span>
      </div>

      {/* Cheque/EFTA Number */}
      <div className="flex items-center">
        <span className="font-semibold text-[15px] w-[40%]">Cheque/EFTA Number:</span>
        <div className="flex space-x-1 mt-1">
          {cheque?.split("").map((char, index) => (
            <div
              key={index}
              className="w-3 h-3 border border-black flex items-center justify-center text-sm p-2"
            >
              {char}
            </div>
          ))}
        </div>
      </div>
    </div>
    </div>
          </div>
        </div>
      
        
       

     {/* Description Section */}
        <div className="mt-1">
          <p><strong>DESCRIPTION OF PAYMENT</strong></p>
          <div className="h-8 border-t border-b border-gray-700 p-2 text-sm">
            {description}
          </div>
          
          <p className="mt-1"><strong>AMOUNT IN WORDS</strong></p>
          <div className="h-8 border-t border-b border-gray-700 p-2 text-sm">
          {numberToWords(sumOfArray(allneeded.filter(a=>a.type == 'expense').map(res=>parseFloat(res.amount))))} Kwacha
          </div>
        </div>

    

    


      {renderBudgetDetails()}
      {/* Signatures */}
      <div className="grid grid-cols-2 gap-4 mb-1 text-sm mt-1">
        {renderSignerSection("PREPARED BY", voucherData.preparedBy)}
        {renderSignerSection("CHECKED BY", voucherData.checkedBy)}
        {renderSignerSection("AUTHORISED BY", voucherData.authorisedBy)}
        {renderSignerSection("APPROVED BY", voucherData.approvedBy)}
      </div>

      {/* Received By */}
      <div className="border border-gray-700 text-sm p-1">
      <p className="font-semibold">RECEIVED BY</p>
        <div className="grid grid-cols-2 gap-4">

        <div>
        <p>Name: {voucherData.receivedBy.name}</p>
        <p>Address: {voucherData.receivedBy.address}</p>
        <p>Signature: {voucherData.receivedBy.signature}</p>
        </div>

        <div> 
        <p>NRC No.: {voucherData.receivedBy.nrc}</p>
        <p>Date.: {voucherData.receivedBy.date}</p>
        <p>Contact No.: {voucherData.receivedBy.contactNo}</p>
        </div>
        
       
      </div>
      </div>

      {/* <p className="text-xs mt-1">NOTE: EFTA = ELECTRONIC FUNDS TRANSFER ADVICE</p> */}
    </div>
  );
});

export default PaymentVoucher;
